import ApiMaps from './modules/apiMaps';
import Contact from './modules/formContact';
import Comment from './modules/formComment';
import Slider from './modules/allSlider'
import Modal from "./modules/modal";
import Sticky from "./modules/stickyColor";
import { times } from 'lodash';


class App {
    constructor() {
        
        // this.preloader = new Preloader("preloader");
        
        if (document.getElementById("sticky"))
            new Sticky("sticky", "content");
        
        /* Sliders */
        if (document.getElementsByClassName("swiper-wrapper")[0])
        this.Swiper = new Slider();
        
        /* Modal plano */
        if(document.getElementById("plano"))
        this.plano = new Modal("plano-modal");
        
        /* Modal 360 */
        if (document.getElementById("tresSesenta"))
        this.tresSeis = new Modal("tres-modal");
        
        /* Modal Galeria */
        if (document.getElementById("galeria"))
        this.galeria = new Modal("galeria-modal");
        
        /* Modal Filtro */
        if (document.getElementById("filtro"))
        this.filtro = new Modal("modal-filtro");
        
        /* Modal Gracias */
        if (document.getElementById("modal-gracias")) {
            this.btnForm = new Modal("modal-gracias");
            /* activar Modal de gracias */
            if (window.location.hash == "#gracias") 
                this.btnForm.show();
        }

        /* Modal contactanos*/
        if (document.getElementById("modal-form")) {
            this.modalContacto = new Modal("modal-form");
            /* activar Modal de contactanos*/
            if (window.location.hash == "#contactForm"){
                window.history.replaceState(null, null, window.location.pathname);
                this.modalContacto.show();
            }
            if (window.location.hash == "#slider-video")
                window.history.replaceState(null, null, window.location.pathname + "#slider-video");

        }
        

        this.addEvents();
        
        this.inViewText();
    }

    loaded() {
        /*this.preloader.hide(() => {
            TweenLite.to("#main-wrapper", 0.45, {
                ease: Power2.easeOut,
                opacity: 1,
                y: 0
            });
        });*/
    }

    addEvents() {  

            /*updateSelected */
            var updateSelectedItems = document.getElementsByClassName("updateSelected");

            for (var i = 0; i < updateSelectedItems.length; i++) {

                updateSelectedItems[i].onchange = function(){
                    let inp_label="";
                    /* label bedrooms */
                    if( this.id === "bedrooms"){
                        inp_label = document.getElementById("bedLabel");
                        if (this.value === "") {
                            inp_label.innerText = "Habitaciones";
                        }
                    /*  else if(this.value === "1") {
                            inp_label.innerText  = "Habitación";
                        } */
                        else {
                            inp_label.innerText = "Habitaciones " + this.value;
                        }
                    }

                    /* label bathroom */
                    else if( this.id == "bathrooms"){
                        inp_label = document.getElementById("bathLabel");
                        if (this.value === "") {
                            inp_label.innerText = "Baños";
                        } 
                        /* else if (this.value === "1") {
                            inp_label.innerText = "Baño";
                        } */ 
                        else {
                            inp_label.innerText = "Baños " + this.value;
                        }
                    }

                    /* label parking */
                    else if( this.id == "parking_lot"){
                        inp_label = document.getElementById("parkLabel");
                        if (this.value === "") {
                            inp_label.innerText = "Estacionamientos";
                        } 
                        /* else if (this.value === "1") {
                            inp_label.innerText = "Estacionamiento";
                        } */ 
                        else {
                            inp_label.innerText = "Estacionamiento " + this.value;
                        }
                    }

                    /* label complejo */
                    else if( this.id == "complejo"){
                        inp_label = document.getElementById("complejoLabel");
                        if (this.value === "") {
                            inp_label.innerText = "Complejo";
                        } 
                        else {
                            inp_label.innerText = this.options[this.selectedIndex].text;
                        }
                    }
                     /* label min */
                    else if( this.id == "mts"){
                        inp_label = document.getElementById("mtsLabel");
                        if (this.value === "") {
                            inp_label.innerText = "Mts";
                        } 
                        else {
                            inp_label.innerText = this.value + " Mts";
                        }
                    }
                    
                    /* label min */
                    else if( this.id == "min"){
                        inp_label = document.getElementById("minLabel");
                        if (this.value === "") {
                            inp_label.innerText = "$Min";
                        } 
                        else {
                            inp_label.innerText = "$Min " + this.value;
                        }
                    }

                    /* label max */
                    else if( this.id == "max"){
                        inp_label = document.getElementById("maxLabel");
                        if (this.value === "") {
                            inp_label.innerText = "$Max";
                        } else {
                            inp_label.innerText = "$Max " + this.value;
                        }
                    }
                };

            }
        
        /* si esta el redes sociales  */
        if (document.getElementById("social"))
            window.addEventListener("scroll", ()=>{
                this.redesScroll();
            });

        /* Click para mostrar menu*/

        if(document.getElementById("sliderMenu")){
            document.getElementById("menu").addEventListener('click', () => {
                let  btn = document.getElementById("sliderMenu");
                
                if (btn.style.display == "none" || btn.style.display == "") {
                    btn.style.display = "block";
                } else {
                    btn.style.display = "none";
                }
            });
            document.getElementById("btnclose").addEventListener('click', () => {
                let  btn = document.getElementById("sliderMenu");
                if (btn.style.display === "none") {
                    btn.style.display = "block";
                } else {
                    btn.style.display = "none";
                }
            });
        }

        /*Reproductor */

        if(document.getElementById("video")){
            let  video = document.getElementById("video");
            video.addEventListener("click", function(event) { 
                if (video.paused == true) {
                    video.play();
                }
                else{
                    video.pause();
                }
          });
        }


        /* Ver fotos onClick */
        if (document.getElementById("galeria"))
            window["galeria"].addEventListener("click", (e) => {
                e.preventDefault();
                 this.galeria.show();
            }, false);

        /* Ver plano onClick */
        if (document.getElementById("plano"))
            window["plano"].addEventListener("click", (e) => {
                e.preventDefault();
                this.plano.show();
            }, false);

        /* Ver 360 onClick */
         if (document.getElementById("tresSesenta"))
             window["tresSesenta"].addEventListener("click", (e) => {
                 e.preventDefault();
                 /* inserta el frame en el modal */
                 window["lnkTres"].innerHTML = `<iframe title="Vista 360" src=${window["tresSesenta"].dataset.key}></iframe>`;
                 /* muestra el modal */
                 this.tresSeis.show();
             }, false);

        /* Ver filtro onClick */
        if (document.getElementById("filtro"))
            window["filtro"].addEventListener("click", (e) => {
                e.preventDefault();
                /* muestra el modal */
                this.filtro.show();
            }, false);  

        /* validacion formulario contacto */
        if (document.getElementById('contactForm'))
            this.val = new Contact();
        
        /* validacion formulario comentarios */
        if (document.getElementById('modal-form')){
            
            this.val = new Contact();

            let _el = document.getElementById('numDptoI');
                _el.addEventListener('change', () => {
                    let _numDepto = _el.options[_el.selectedIndex].value;
                    let _nombreDepto = _el.options[_el.selectedIndex].text.split(" ").join("-");
                    let returnUrl = document.getElementById("retURL");
                    let dataDept = document.getElementById("00N5x000003UcWR");

                    dataDept.value = _numDepto;
                    returnUrl.value = returnUrl.dataset.url + "/" + _nombreDepto + "#gracias";
                    
                 });
        }

        /* mapa */
        if (document.getElementById("map")){
            let map = document.getElementById("map");
            /* coordenadas del mapa */
            let coord = {
                lat: parseFloat(map.dataset.lat),
                lng: parseFloat(map.dataset.lng)
            };
            /* mapa a pintar */
            this.mapStyl = new ApiMaps(coord, "map", "contInt");
        }
        
        /* GALERIAS rezise*/
        if (document.getElementById("dscrDpt")) {
            let galeria = document.getElementById("planoGaleria");
            let descripcion = document.getElementById("dscrDpt");
            let contenido = document.getElementsByClassName("centerVert")[0];
            let _height = contenido.getBoundingClientRect().height + 90;

            galeria.style.height = _height + "px";
            descripcion.style.height = _height + "px";
        }

         /* select resize */
         if (document.getElementById("home-form")) {
            let _vwHome = document.getElementById("home-form").getBoundingClientRect().width;
            let _vwMin = document.getElementById("min").getBoundingClientRect().width * 2;
            let _vwselect = document.getElementById("bedrooms");
            let vw = _vwHome - _vwMin;
            _vwselect.style.width = "calc(" + vw + "px - (48px + 2.9vw) )";

            /* se actualice siempre */
            window.addEventListener("resize", () =>{
                let _vwHome = document.getElementById("home-form").getBoundingClientRect().width;
                let _vwMin = document.getElementById("min").getBoundingClientRect().width * 2;
                let vw = _vwHome - _vwMin;
                _vwselect.style.width = "calc(" + vw + "px - (48px + 2.9vw) )";
            })
            
         }
        
       
        /* desactivar botones de buscador al enviar */
        if (document.getElementsByClassName("btnSearch")[0]) {
            /* ocultar alerta de precios*/
            let selectElement = document.getElementsByClassName('validateF');
             Array.prototype.forEach.call(selectElement, (_ele, index) => {
                _ele.addEventListener('change', (event, i= index) => {
                    let _min = document.getElementById("min").value;
                    let _max = document.getElementById("max").value;
                    if (_min != "") _min = parseInt(_min);
                    if (_max != "") _max = parseInt(_max);
                    if (_min >= _max && (_min > 0 && _max > 0)) {
                        document.getElementById("alertMonto").style.display = "inline-block";
                    } else {
                        document.getElementById("alertMonto").style.display = "none";
                    }
                });
             })

             /* bloquear boton para que solo se envie 1 vez  */
            var buscador = document.getElementsByClassName("btnSearch");
            Array.prototype.forEach.call(buscador, (btn,index) => {
                btn.addEventListener("click", function (e, i=index) {
                    this.disabled = true;
                    e.preventDefault();
                    let min = document.getElementById("min").value;
                    let max = document.getElementById("max").value;
                    if (min != "") min= parseInt(min);
                    if (max != "") max = parseInt(max);
                    if( min >= max && (min > 0 && max > 0 )){
                        document.getElementById("alertMonto").style.display = "inline-block";
                        this.disabled = false;
                    }else {
                       document.getElementsByClassName("form-search")[i].submit();
                    }
                })
            })
            
        }

        /* anclas */
        if (document.getElementsByClassName("ncl")[0]){
            let anclas = document.getElementsByClassName("ncl");
            Array.prototype.forEach.call(anclas, (btn) => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    let id = e.target.getAttribute("href").replace("#", "");
                    let seccion = document.getElementById(id);
                    let scrollY = seccion.getBoundingClientRect().top + window.scrollY;
                    let scroll = {
                        y: window.scrollY
                    }

                    TweenMax.to(scroll, 0.5, {
                        y: scrollY,
                        onUpdate: () => {
                            window.scroll(0, scroll.y)
                        }
                    })
                });
            });
        }
    }
    
    redesScroll(){
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
            document.getElementById("social").classList.add("change");
        } else {
            document.getElementById("social").classList.remove("change");
        }
    }

    inViewText(){
        inView('.inview-item').on('enter', el => {
            TweenMax.to(el, 0.5, {
                ease: Power2.easeOut,
                delay: Math.random() * 0.25,
                scaleX: 1,
                scaleY: 1,
                opacity: 1,
                y: 0
            });
        }).on('exit', el => {
            TweenMax.set(el, {
                opacity: 0,
                y: 25,
                scaleX: 1,
                scaleY: 0.9
            });
        });
    }   

}


window.app = new App();
window.onload = () => {
    window.app.loaded();  
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js